import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "../api.config";

export const wholesaleOfferCalcApi = createApi({
  reducerPath: "wholesaleOfferCalcApi",
  baseQuery: baseQueryWithReauth,
  tagTypes: ["WholesaleOfferCalc"],
  endpoints: (build) => ({
    // Get all calculations
    getAllCalculations: build.query({
      query: ({ page = 1, limit = 50, starred } = {}) => ({
        url: "/wholesale/offer-calc",
        method: "GET",
        params: { page, limit, starred },
      }),
      providesTags: ["WholesaleOfferCalc"],
    }),

    // Get calculation by ID
    getCalculationById: build.query({
      query: (id) => ({
        url: `/wholesale/offer-calc/${id}`,
        method: "GET",
      }),
      providesTags: (result, error, id) => [{ type: "WholesaleOfferCalc", id }],
    }),

    // Create calculation
    createCalculation: build.mutation({
      query: (calculation) => ({
        url: "/wholesale/offer-calc",
        method: "POST",
        body: calculation,
      }),
      invalidatesTags: ["WholesaleOfferCalc"],
    }),

    // Update calculation
    updateCalculation: build.mutation({
      query: ({ id, ...calculation }) => ({
        url: `/wholesale/offer-calc/${id}`,
        method: "PUT",
        body: calculation,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: "WholesaleOfferCalc", id },
        "WholesaleOfferCalc",
      ],
    }),

    // Delete calculation
    deleteCalculation: build.mutation({
      query: (id) => ({
        url: `/wholesale/offer-calc/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["WholesaleOfferCalc"],
    }),

    // Toggle star
    toggleCalculationStar: build.mutation({
      query: (id) => ({
        url: `/wholesale/offer-calc/${id}/star`,
        method: "PATCH",
      }),
      invalidatesTags: (result, error, id) => [
        { type: "WholesaleOfferCalc", id },
        "WholesaleOfferCalc",
      ],
    }),

    // Calculate MAO (stateless - doesn't save)
    calculateMAO: build.mutation({
      query: ({ arv, repairEstimate, wholesaleFee, percentOfArv, holdingCosts, closingCosts }) => ({
        url: "/wholesale/offer-calc/calculate",
        method: "POST",
        body: { arv, repairEstimate, wholesaleFee, percentOfArv, holdingCosts, closingCosts },
      }),
    }),

    // Get calculations for a seller
    getCalculationsForSeller: build.query({
      query: (sellerId) => ({
        url: `/wholesale/offer-calc/seller/${sellerId}`,
        method: "GET",
      }),
      providesTags: ["WholesaleOfferCalc"],
    }),

    // Get calculations for a deal
    getCalculationsForDeal: build.query({
      query: (dealId) => ({
        url: `/wholesale/offer-calc/deal/${dealId}`,
        method: "GET",
      }),
      providesTags: ["WholesaleOfferCalc"],
    }),
  }),
});

export const {
  useGetAllCalculationsQuery,
  useGetCalculationByIdQuery,
  useCreateCalculationMutation,
  useUpdateCalculationMutation,
  useDeleteCalculationMutation,
  useToggleCalculationStarMutation,
  useCalculateMAOMutation,
  useGetCalculationsForSellerQuery,
  useGetCalculationsForDealQuery,
} = wholesaleOfferCalcApi;
